// Lógica pura para decidir si /version.json anuncia un build nuevo.
// Extraída del plugin pwa-update.client.ts para poder testearla sin browser.

export interface VersionStamp {
  id: string
  t: number
}

/** Parsea/valida el body de /version.json. Devuelve null si no tiene forma esperada. */
export function parseVersionStamp(raw: unknown): VersionStamp | null {
  if (!raw || typeof raw !== 'object') return null
  const id = (raw as Record<string, unknown>).id
  const t = (raw as Record<string, unknown>).t
  if (typeof id !== 'string' || id === '') return null
  if (typeof t !== 'number' || !Number.isFinite(t)) return null
  return { id, t }
}

/**
 * ¿`incoming` es un build genuinamente MÁS NUEVO que `known`?
 *
 * Requiere que el id cambie Y que el timestamp avance (monotónico). El guard de
 * tiempo es defensa-en-profundidad contra flapping del edge: si algún PoP llega
 * a servir un build VIEJO (timestamp menor), NO se notifica — así nunca se
 * dispara un toast falso por un valor que "regresó" hacia atrás.
 *
 * Comparación ESTRICTA (`>`) a propósito: `t` es el wall-clock del build (Date.now()
 * congelado al prerenderizar). Builds secuenciales en CI tardan minutos → el build
 * más nuevo SIEMPRE tiene `t` estrictamente mayor; dos builds en el mismo ms es
 * físicamente imposible. Y `applyUpdate()` ya está limitado a 1 toast por sesión
 * (`updateNotified`), así que aunque algo se colara, el peor caso es 1 aviso.
 */
export function isNewerVersion(known: VersionStamp | null, incoming: VersionStamp | null): boolean {
  if (!incoming || !known) return false
  if (incoming.id === known.id) return false
  return incoming.t > known.t
}
